import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
  styleUrls: ['./yes-no-dialog.component.scss']
})
export class YesNoDialogComponent {

  constructor(public dialogRef: MatDialogRef<YesNoDialogComponent>) {}

  // Close dialog with 'Yes'
  onYes(): void {
    this.dialogRef.close('Yes');
  }

  // Close dialog with 'No'
  onNo(): void {
    this.dialogRef.close('No');
  }
}
